export const parsePaginationCursor = (
  url: string | null | undefined
): string | null => {
  if (url == null || url === "") return null;
  const queryString = url.includes("?") ? url.slice(url.indexOf("?") + 1) : url;
  return new URLSearchParams(queryString).get("start_at");
};

export const parsePaginationCursors = (meta?: {
  next: string | null;
  previous: string | null;
}): { nextCursor: string | null; previousCursor: string | null } => ({
  nextCursor: parsePaginationCursor(meta?.next),
  previousCursor: parsePaginationCursor(meta?.previous),
});
